<template>
  <div id="demo-basic-card" class="margin-top">
    <div id="dashboard-analytics">
      <!-- <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
                <vs-tab label="Thống kê theo chủ đề" icon-pack="feather" icon="icon-user"> -->
      <trial-confirm v-if="typeTrial == 0 || typeTrial" :topicId="topicId"></trial-confirm>
      <div class="vx-row">
        <vx-card :headerPadding="true" class="p-1 pt-1">
          <div class="vx-row">
            <div class="vx-col md:w-3/12 selected-dropdown w-full mt-1">
              <vs-dropdown id="dropdown-left" vs-custom-content vs-trigger-click class="cursor-pointer w-full label-selected pr-4">
                <label for="" class="ml-3 font-weight-bold">{{ $t("articleBookmark.project") }}:</label>
                <vs-button v-if="filterProject" type="border" icon-pack="feather" icon="icon-clipboard" style="margin-left:10px" class="text-size w-full mt-1">
                  {{ topicGroupByProjectList }}
                </vs-button>
                <vs-button v-else type="border" icon-pack="feather" icon="icon-clipboard" style="margin-left:10px" class="text-size w-full mt-1">
                  {{ labelGroup }}
                </vs-button>
                <vs-dropdown-menu class="" style="width:250px;max-height:20rem">
                  <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0">
                    <vs-dropdown-item
                      v-for="(item, index) in optionGroupTopics"
                      :key="index"
                      style="overflow:auto;max-height:200px"
                      @click="searchByTopicGroup(item)"  >
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <span class="ml-2 text-size" style="vertical-align:middle">
                          {{ item.label }}
                        </span>
                      </li>
                    </vs-dropdown-item>
                  </VuePerfectScrollbar>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <div class="vx-col md:w-3/12 selected-dropdown w-full mt-1">
              <vs-dropdown id="dropdown-left" vs-custom-content vs-trigger-click class="cursor-pointer w-full label-selected pr-4">
                <label for="" class="ml-3 font-weight-bold">{{ $t("topic") }}:</label>
                <vs-button
                  type="border"
                  icon-pack="feather"
                  icon="icon-clipboard"
                  style="margin-left:10px"
                  class="text-size w-full mt-1">
                  {{ labelTopic }}
                </vs-button>
                <vs-dropdown-menu class="" style="width:250px;max-height:20rem">
                  <VuePerfectScrollbar
                    ref="scrollDialog"
                    class="scroll-area--nofications-dropdown p-0">
                    <vs-dropdown-item
                      v-for="(item, index) in optionTopics"
                      :key="index"
                      style="overflow:auto;max-height:200px"
                      @click="searchByTopic(item)">
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <span
                          class="ml-2 text-size"
                          style="vertical-align:middle">
                          {{ item.topicName }}
                        </span>
                      </li>
                    </vs-dropdown-item>
                  </VuePerfectScrollbar>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <div
              class="vx-col mb-2 md:w-4/12 selected-dropdown w-full mt-1 pl-8"
              style="display:grid">
              <label for="" class="font-weight-bold">
                {{ $t("time") }}:
              </label>
              <date-range-picker
                class="w-full"
                ref="picker"
                :locale-data="{ format: 'dd/mm/yyyy' }"
                :opens="'left'"
                @update="initScreen"
                v-model="dateRange">
              </date-range-picker>
            </div>
            <div class="vx-col md:w-2/12 w-full mt-4 pl-8">
            <vs-button
              class="w-full"
              icon="icon-download"
              icon-pack="feather"
              style="border-radius:10px"
              @click="exportExcel">
              {{ $t("download") }}
            </vs-button>
          </div>
          </div>
        </vx-card>
      </div>
      <!-- biểu đồ dung lượng(capacity chart) -->
      <div class="vx-row">
        <div class="vx-col mt-2 w-full md:w-3/12 pl-0">
          <div class="vx-col w-full mb-3 mt-2">
            <statistics-card-line
              icon="FileTextIcon"
              type="area"
              color="success"
              :height="61"
              :hideChart="true"
              :statistic="parseInt(totalMentioned)"
              :statisticTitle="$t('managerKeyword.posts')"
            />
          </div>
          <div class="vx-col w-full mb-3 mt-2">
            <statistics-card-line
              icon="MessageSquareIcon"
              type="area"
              color="purple"
              height="91"
              :hideChart="true"
              :statistic="parseInt(totalDiscuss)"
              :statisticTitle="$t('articleBookmark.comment')"
            />
          </div>
          <div class="vx-col w-full mb-3 mt-2">
            <statistics-card-line
              icon="Share2Icon"
              type="area"
              color="warning"
              height="91"
              :hideChart="true"
              :statistic="parseInt(totalShare)"
              :statisticTitle="$t('articleBookmark.share')"
            />
          </div>
          <div class="vx-col w-full mt-2">
            <statistics-card-line
              icon="AtSignIcon"
              type="area"
              color="primary"
              height="91"
              :hideChart="true"
              :statistic="parseInt(percentData)"
              :statisticTitle="$t('totalDataCollected')"
              :checkPercent="true"
            />
          </div>
        </div>

        <div class="vx-col mt-2 w-full md:w-9/12 p-0">
          <div class="vx-card mt-2 p-6 height-card">
            <div class="component">
              <span class="text-title">
                {{ $t("capacity") }}
                <div v-if="!showWorkChart" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </span>
            </div>
            <div class="component">
              <span class="text-time-title">
                {{ countDays }} {{ $t("day")}}
                <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                </span>
              </span>
            </div>
            <div id="chart">
              <vue-apex-charts
                v-if="showWorkChart"
                type="bar"
                height="300"
                :options="capacityChart.chartOptions"
                :series="capacityChart.series">
              </vue-apex-charts>
            </div>
          </div>
        </div>
      </div>

      <!-- biểu đồ nguồn tin (article chart) -->
      <div class="vx-row">
        <div class="vx-col mt-2 w-full md:w-2/3 pl-0">
          <div class="vx-card mt-2 p-6 height-card">
            <div class="component">
              <span class="text-title">
                {{ $t("informationResource") }}
                <div v-if="!showArticleChart" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </span>
            </div>
            <div class="component">
              <span class="text-time-title">
                {{ countDays }} {{ $t("day")}}
                <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                </span>
              </span>
            </div>
            <div id="aricleChart">
              <vue-apex-charts
                v-if="showArticleChart"
                type="bar"
                height="300"
                :options="articleChart.chartOptions"
                :series="articleChart.series">
              </vue-apex-charts>
            </div>
          </div>
        </div>

        <div class="vx-col mt-2 w-full md:w-1/3 p-0">
          <div class="vx-card mt-2 p-6 height-card">
            <div class="component">
              <span class="text-title">{{ $t("informationResource") }}
                <div v-if="!showDonutChartSource" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </span>
            </div>
            <div class="component">
              <span class="text-time-title">
                {{ countDays }} {{ $t("day")}}
                <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                </span>
              </span>
            </div>
            <div id="chart">
              <vue-apex-charts
                v-if="showDonutChartSource"
                type="donut"
                :options="donutArticleChart.chartOptions"
                :series="donutArticleChart.series"
                height="300">
              </vue-apex-charts>
            </div>
          </div>
        </div>
      </div>

      <!-- biều đồ sắc thái (classification chart) -->
      <div class="vx-row">
        <div class="vx-col mt-2 w-full md:w-1/3 pl-0">
          <div class="vx-card mt-2 p-6 height-card">
            <div class="component">
              <span class="text-title">
                {{ $t("title.shades") }}
                <div v-if="!showDonutChartClassification" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </span>
            </div>
            <div class="component">
              <span class="text-time-title">
                {{ countDays }} {{ $t("day")}}
                <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                </span>
              </span>
            </div>
            <div id="chart">
              <vue-apex-charts
                v-if="showDonutChartClassification"
                type="donut"
                :options="donutClassificationChart.chartOptions"
                :series="donutClassificationChart.series"
                height="300">
              </vue-apex-charts>
            </div>
          </div>
        </div>
        <div class="vx-col mt-2 w-full md:w-2/3 p-0">
          <div class="vx-card mt-2 p-6 height-card">
            <div class="component">
              <span class="text-title">{{ $t("title.shades") }}
                <div v-if="!showClassificationChart" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                  </div>
                </span>
            </div>
            <div class="component">
              <span class="text-time-title">
                {{ countDays }} {{ $t("day")}}
                <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                </span>
              </span>
            </div>
            <div id="aricleChart">
              <vue-apex-charts
                v-if="showClassificationChart"
                type="line"
                height="300"
                :options="classificationChart.chartOptions"
                :series="classificationChart.series">
              </vue-apex-charts>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mt-2 w-full md:w-2/3 pl-0">
          <div class="vx-card mt-2 p-6 height-card">
            <div class="component">
              <span class="text-title">
                {{ $t("topNews") }}
                <div v-if="!showTopKeyword" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </span>
            </div>
            <div class="component">
              <span class="text-time-title">
                {{ countDays }} {{ $t("day")}}
                <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                </span>
              </span>
            </div>
            <vs-table
              stripe
              :data="defaultWords"
              :noDataText="this.$t('noData')"
              class="w-full mt-2 table-dashboard">
              <template>
                <vs-tr
                  v-for="(item, index) in defaultWords.slice(0, 5)"
                  :data="item"
                  :key="index">
                  <vs-td class="md:w-1/12">
                    <span class="title-content">{{ item.stt }}</span>
                  </vs-td>
                  <vs-td class="md:w-10/12 truncate">
                    <div class="w-full component cursor-pointer" @click="openURL(item)">
                      <div class="component w-full">
                        <span class="title-content">{{ item.title.slice(0,60) }}...</span>
                      </div>
                      <div class="component w-full">
                        <span class="text-content">
                          {{ item.content.slice(0, 60) }}...
                        </span>
                      </div>
                    </div>
                  </vs-td>
                  <vs-td class="text-value md:w-1/12">
                    <progress-circle
                      :completed-steps="item.percent"
                      :total-steps="100"
                      :circle-color="cp_circleColor"
                      :start-color="item.color"
                      :stop-color="item.color"
                      :circle-width="cp_circleWidth"
                      :diameter="cp_diameter">
                    </progress-circle>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="vx-col mt-2 w-full md:w-1/3 p-0">
          <div class="vx-card mt-2 p-6 height-card">
            <div class="component">
              <span class="text-title">{{ $t("topDomain") }}
                <div v-if="!showTopDomain" class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </span>
            </div>
            <div class="component">
              <span class="text-time-title">
                {{ countDays }} {{ $t("day")}}
                <span v-if="countDays > 1 && $i18n.locale == 'en'">s
                </span>
              </span>
            </div>

            <vs-table stripe :data="listTopDomain" :noDataText="this.$t('noData')"  class="w-full mt-2 table-dashboard">
              <template>
                <vs-tr
                  v-for="(item, index) in listTopDomain.slice(0, 5)"
                  :data="item"
                  :key="index">
                  <vs-td class="md:w-1/12 image-center">
                    <img :src="getImageByDomain(item.domain)" alt="" />
                  </vs-td>
                  <vs-td>
                    <div class="component w-full">
                      <span>{{ item.name }}</span>
                    </div>
                    <div class="component w-full text-content">
                      <span>{{ item.domain }}</span>
                    </div>
                  </vs-td>
                  <vs-td class="text-content md:w-1/12">
                    <span>{{ eArabic(item.count) }}</span>
                  </vs-td>
                  <vs-td class="text-value md:w-1/12">
                    <progress-circle
                      :completed-steps="item.percent"
                      :total-steps="100"
                      :circle-color="cp_circleColor"
                      :start-color="item.color"
                      :stop-color="item.color"
                      :circle-width="cp_circleWidth"
                      :diameter="cp_diameter">
                    </progress-circle>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>

<!--      biểu đồ giới tính-->
<!--      <div class="vx-row">-->
<!--        <div class="vx-col mt-2 w-full md:w-5/12 pl-0">-->
<!--          <div class="vx-card mt-2 p-6 height-card">-->
<!--            <div class="component">-->
<!--              <span class="text-title">-->
<!--                {{ $t("title.gender") }}-->
<!--              </span>-->
<!--            </div>-->
<!--            <div class="component">-->
<!--              <span class="text-time-title">-->
<!--                {{ countDays }} {{ $t("day")}}-->
<!--                <span v-if="countDays > 1 && $i18n.locale == 'en'">s-->
<!--                </span>-->
<!--              </span>-->
<!--            </div>-->
<!--            <div class="vx-row ml-3" style="margin-top: 90px;">-->
<!--              <div class="vx-col mt-2 w-full md:w-1/5 pl-0">-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100pt" height="100pt" viewBox="0 0 100 100" version="1.1">-->
<!--                  <g id="surface1">-->
<!--                    <path style=" stroke:none;fill-rule:nonzero;fill:rgb(47,128,237);fill-opacity:1;" d="M 36 94 C 36 96.464844 37.535156 98 40 98 C 42.46875 98 44 96.464844 44 94 L 44 56 L 48 56 L 48 94 C 48 96.460938 49.535156 98 52 98 C 54.464844 98 56 96.464844 56 94 L 56 30 L 58 30 L 58 53.628906 C 58 58.417969 64.011719 58.417969 64 53.628906 L 64 29.320312 C 64 24.03125 60.1875 20 54 20 L 38 20 C 32.359375 20 28 23.4375 28 29.175781 L 28 54 C 28 58 34 58 34 54 L 34 30 L 36 30 Z M 36 94 "/>-->
<!--                    <path style=" stroke:none;fill-rule:nonzero;fill:rgb(47,128,237);fill-opacity:1;" d="M 54 9.25 C 54 13.804688 50.304688 17.5 45.75 17.5 C 41.195312 17.5 37.5 13.804688 37.5 9.25 C 37.5 4.695312 41.195312 1 45.75 1 C 50.304688 1 54 4.695312 54 9.25 Z M 54 9.25 "/>-->
<!--                  </g>-->
<!--                </svg>-->

<!--              </div>-->
<!--              <div class="vx-col mt-2 w-full md:w-1/5 pl-0">-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100pt" height="100pt" viewBox="0 0 100 100" version="1.1">-->
<!--                  <g id="surface1">-->
<!--                    <path style=" stroke:none;fill-rule:nonzero;fill:rgb(255,175,175);fill-opacity:1;" d="M 54 9.25 C 54 13.804688 50.304688 17.5 45.75 17.5 C 41.195312 17.5 37.5 13.804688 37.5 9.25 C 37.5 4.695312 41.195312 1 45.75 1 C 50.304688 1 54 4.695312 54 9.25 Z M 54 9.25 "/>-->
<!--                    <path style=" stroke:none;fill-rule:nonzero;fill:rgb(255,175,175);fill-opacity:1;" d="M 65.824219 64 L 54.007812 31.527344 L 53.941406 31.191406 C 53.941406 30.71875 54.339844 30.335938 54.835938 30.335938 C 55.257812 30.335938 55.609375 30.617188 55.703125 30.992188 L 63.738281 52 C 64.273438 53.203125 66.46875 54 67.910156 54 C 69.84375 54 70.042969 50.210938 70 50 L 61.964844 29.285156 C 61.269531 24.644531 56.578125 20 51.230469 20 L 40.761719 20 C 35.410156 20 30.375 24.644531 29.675781 29.285156 L 22.003906 50 C 21.828125 50.398438 22.003906 54 24.089844 54 C 25.710938 54 27.867188 53.433594 28.261719 52 L 36.011719 30.902344 C 36.136719 30.570312 36.46875 30.335938 36.855469 30.335938 C 37.347656 30.335938 37.746094 30.71875 37.746094 31.191406 L 37.691406 31.496094 L 26.175781 64 C 26.152344 64.097656 26.175781 65.902344 26.175781 66 C 26.175781 66.691406 27.847656 68 28.570312 68 L 36 68 L 36 94.191406 C 36 96.269531 37.832031 98 40 98 C 42.167969 98 44 96.269531 44 94.191406 L 44 67.980469 C 44 67.414062 48 67.433594 48 68 L 48 94 C 48 96.078125 49.835938 98 52 98 C 54.171875 98 56 96.078125 56 94 L 56 68 L 63.738281 68 C 64.460938 68 65.824219 66.691406 65.824219 66 C 65.824219 65.839844 65.882812 64.136719 65.824219 64 Z M 65.824219 64 "/>-->
<!--                  </g>-->
<!--                </svg>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="vx-col mt-2 w-full md:w-7/12 p-0">-->
<!--          <div class="vx-card mt-2 p-6 height-card">-->
<!--            <div class="component">-->
<!--              <span class="text-title">{{ $t("title.shades") }}-->
<!--                </span>-->
<!--            </div>-->
<!--            <div class="component">-->
<!--              <span class="text-time-title">-->
<!--                {{ countDays }} {{ $t("day")}}-->
<!--                <span v-if="countDays > 1 && $i18n.locale == 'en'">s-->
<!--                </span>-->
<!--              </span>-->
<!--            </div>-->
<!--            <div class="vx-col">-->
<!--              <div class="vx-row ml-8">-->
<!--                <div class="vx-col mt-2 w-full md:w-1/3 p-0 ">-->
<!--                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100pt" height="100pt" viewBox="0 0 100 100" version="1.1">-->
<!--                    <g id="surface1">-->
<!--                      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(255,175,175);fill-opacity:1;" d="M 54 9.25 C 54 13.804688 50.304688 17.5 45.75 17.5 C 41.195312 17.5 37.5 13.804688 37.5 9.25 C 37.5 4.695312 41.195312 1 45.75 1 C 50.304688 1 54 4.695312 54 9.25 Z M 54 9.25 "/>-->
<!--                      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(255,175,175);fill-opacity:1;" d="M 65.824219 64 L 54.007812 31.527344 L 53.941406 31.191406 C 53.941406 30.71875 54.339844 30.335938 54.835938 30.335938 C 55.257812 30.335938 55.609375 30.617188 55.703125 30.992188 L 63.738281 52 C 64.273438 53.203125 66.46875 54 67.910156 54 C 69.84375 54 70.042969 50.210938 70 50 L 61.964844 29.285156 C 61.269531 24.644531 56.578125 20 51.230469 20 L 40.761719 20 C 35.410156 20 30.375 24.644531 29.675781 29.285156 L 22.003906 50 C 21.828125 50.398438 22.003906 54 24.089844 54 C 25.710938 54 27.867188 53.433594 28.261719 52 L 36.011719 30.902344 C 36.136719 30.570312 36.46875 30.335938 36.855469 30.335938 C 37.347656 30.335938 37.746094 30.71875 37.746094 31.191406 L 37.691406 31.496094 L 26.175781 64 C 26.152344 64.097656 26.175781 65.902344 26.175781 66 C 26.175781 66.691406 27.847656 68 28.570312 68 L 36 68 L 36 94.191406 C 36 96.269531 37.832031 98 40 98 C 42.167969 98 44 96.269531 44 94.191406 L 44 67.980469 C 44 67.414062 48 67.433594 48 68 L 48 94 C 48 96.078125 49.835938 98 52 98 C 54.171875 98 56 96.078125 56 94 L 56 68 L 63.738281 68 C 64.460938 68 65.824219 66.691406 65.824219 66 C 65.824219 65.839844 65.882812 64.136719 65.824219 64 Z M 65.824219 64 "/>-->
<!--                    </g>-->
<!--                  </svg>-->
<!--                </div>-->
<!--              </div>-->
<!--              <hr>-->
<!--              <div class="vx-row ml-8">-->
<!--                <div class="vx-col mt-2 w-full md:w-1/3 p-0 ">-->
<!--                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100pt" height="100pt" viewBox="0 0 100 100" version="1.1">-->
<!--                    <g id="surface1">-->
<!--                      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(47,128,237);fill-opacity:1;" d="M 36 94 C 36 96.464844 37.535156 98 40 98 C 42.46875 98 44 96.464844 44 94 L 44 56 L 48 56 L 48 94 C 48 96.460938 49.535156 98 52 98 C 54.464844 98 56 96.464844 56 94 L 56 30 L 58 30 L 58 53.628906 C 58 58.417969 64.011719 58.417969 64 53.628906 L 64 29.320312 C 64 24.03125 60.1875 20 54 20 L 38 20 C 32.359375 20 28 23.4375 28 29.175781 L 28 54 C 28 58 34 58 34 54 L 34 30 L 36 30 Z M 36 94 "/>-->
<!--                      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(47,128,237);fill-opacity:1;" d="M 54 9.25 C 54 13.804688 50.304688 17.5 45.75 17.5 C 41.195312 17.5 37.5 13.804688 37.5 9.25 C 37.5 4.695312 41.195312 1 45.75 1 C 50.304688 1 54 4.695312 54 9.25 Z M 54 9.25 "/>-->
<!--                    </g>-->
<!--                  </svg>-->
<!--                </div>-->
<!--              </div>-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import DateRangePicker from "@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue";
import VueApexCharts from "vue-apexcharts";
import wordcloud from "vue-wordcloud";
import VueWordCloud from "vuewordcloud";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import authConfig from "@/../auth_config.json";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import TrialConfirm from './v2/pages/guest-dashboard/TrialConfirm.vue'

import { ProgressCircle } from "vue-progress-circle";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  components: {
    TrialConfirm,
    vSelect,
    DateRangePicker,
    VueApexCharts,
    wordcloud,
    VueWordCloud,
    moment,
    VuePerfectScrollbar,
    authConfig,
    ProgressCircle,
    StatisticsCardLine
  },
  data() {
    return {
      typeTrial: null,
      filterProject : false,
      topicGroupByProjectList : null,
      cp_circleColor: "#E9ECEF",
      cp_circleWidth: 4,
      cp_startColor: "#2F80ED",
      cp_diameter: 31,
      cp_stopColor: "#2F80ED",
      //keyword chart
      fontSize: [14, 20],
      rotate: { from: 0, to: 0, numOfOrientation: 0 },
      showTooltip: false,
      fontWordCloud: "'Spectral SC', serif",
      myColors: ["#2F80ED"],
      defaultWords: [],

      selectedTopic: null,
      selectedGroup: null,
      optionGroupTopics: [],
      optionTopics: [],

      dateRange: {
        endDate: new Date(),
        startDate: (() => {
          let date = new Date();
          date.setDate(date.getDate() - 6);
          date.setHours(0, 0, 0);
          return date;
        })()
      },

      //mention
      mention: {},
      shade: {},
      totalMentioned: "",
      percentMentioned: null,
      increaseMentioned: false,
      countDays: 0,
      percentData: null,

      //comment
      totalDiscuss: "",
      percentDiscuss: null,
      increaseDiscuss: false,
      totalCommentFrom: "",

      //share
      totalShare: "",
      percentShare: null,
      increaseShare: false,
      totalShareFrom: "",

      //show chart
      showWorkChart: false,
      showClassificationChart: false,
      showArticleChart: false,
      showDonutChartSource: false,
      showDonutChartClassification: false,
      showTopKeyword: false,
      showTopDomain: false,
      workChartData: {},

      //data keyword
      listDataKeyword: [],

      //data top domain
      listTopDomain: [],

      //text label selected
      labelGroup: this.$t('all'),
      labelTopic: this.$t('all'),

      //text day
      checkSelectedDay: false,
      checkselectedWeeks: false,
      checkSelectedMonth: false,

      //topicGroup
      topicGroupId: null,

      //Topic
      topicId: null,
      listTopics: [],

      //chart pp
      capacityChart: {
        series: [],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
            // stackType: '100%'
          },
          colors: ["#2F80ED", "#27AE60", "#9B51E0", "#F2994A"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }
          ],
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              showDuplicates: false,
              formatter: function(val) {
                if (!val) return val;
                let dateSplit = val.split("-"),
                  type = dateSplit[1],
                  dateTemp = moment(dateSplit[0], "YYYYMMDD");

                if (type === "W") return `Tuần ${dateTemp.isoWeek()}`;

                if (type === "M")
                  return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

                return val.slice(6, 8) + "/" + val.slice(4, 6);
              },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            categories: [],
            tooltip: {
              enabled: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                if (Number(val) === val && val % 1 !== 0) {
                  return kFormatter(val).toFixed(1);
                } else {
                  return kFormatter(val);
                }
              }
            },
            grid: {
              show: false
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: "top",
            // offsetX: 0,
            // offsetY: 50
            markers: {
              fillColors: ["#2F80ED", "#27AE60", "#9B51E0", "#F2994A"]
            }
          }
        }
      },
      articleChart: {
        series: [],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
            stacked: true
            // stackType: '100%'
          },
          colors: [
            "#2F7FED",
            "#003F94",
            "#F2994A",
            "#639400",
            "#5c092f",
            "#F2C94C",
            "#828282",
            "#BDBDBD"
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }
          ],
          xaxis: {
            labels: {
              showDuplicates: false,
              formatter: function(val) {
                if (!val) return val;
                let dateSplit = val.split("-"),
                  type = dateSplit[1],
                  dateTemp = moment(dateSplit[0], "YYYYMMDD");

                if (type === "W") return `Tuần ${dateTemp.isoWeek()}`;

                if (type === "M")
                  return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

                return val.slice(6, 8) + "/" + val.slice(4, 6);
              },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            categories: [],
            tooltip: {
              enabled: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                if (Number(val) === val && val % 1 !== 0) {
                  return kFormatter(val).toFixed(1);
                } else {
                  return kFormatter(val);
                }
              }
            },
            grid: {
              show: false
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: "top",
            // offsetX: 0,
            // offsetY: 50
            markers: {
              fillColors: [
                "#2F7FED",
                "#003F94",
                "#F2994A",
                "#639400",
                "#5c092f",
                "#F2C94C",
                "#828282",
                "#BDBDBD"
              ]
            }
          }
        }
      },
      donutArticleChart: {
        series: [],
        chartOptions: {
          chart: {
            type: "donut",
            toolbar: {
              show: true
            }
          },
          colors: [
            "#2F7FED",
            "#003F94",
            "#F2994A",
            "#639400",
            "#5c092f",
            "#F2C94C",
            "#828282",
            "#BDBDBD"
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          labels: [
            "Tin tức",
            "Facebook",
            "Youtube",
            "Twitter",
            "Forum",
            "Blog & Website",
            "Nguồn đặc biệt"
          ],
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                if (Number(val) === val && val % 1 !== 0) {
                  return kFormatter(val).toFixed(1);
                } else {
                  return kFormatter(val);
                }
              }
            },
            grid: {
              show: false
            }
          },
          legend: {
            position: "bottom",
            // offsetX: 0,
            // offsetY: 50
            markers: {
              fillColors: [
                "#2F7FED",
                "#003F94",
                "#F2994A",
                "#639400",
                "#5c092f",
                "#F2C94C",
                "#828282",
                "#BDBDBD"
              ]
            }
          },
          plotOptions: {
            pie: {
                donut: {
                  background: 'transparent',
                  labels: {
                    show: true,
                    value: {
                      show: true,
                      fontSize: '14px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      fontWeight: 400,
                      color: '#B9B9C3',
                      formatter: function (val, ch) {
                        let total = ch.globals.seriesTotals.reduce((a, b) => {
                          return a + b
                        }, 0);
                        let percent = total !== 0 ? (val / total) * 100 : 0;
                        return percent.toFixed(0) + "%";
                      }
                    },
                    name: {
                      show: true,
                      fontSize: '14px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      fontWeight: 400,
                      color: '#5E5873',
                      // offsetY: -10,
                      formatter: function (val) {
                        if (Number(val) === val && val % 1 !== 0) {
                          return kFormatter(val).toFixed(1);
                        } else {
                          return kFormatter(val);
                        }
                      }
                    },
                    total: {
                      show: true,
                      fontSize: '14px',
                      label: '',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      fontWeight: 400,
                      color: '#5E5873',
                      // offsetY: -10,
                      formatter: function (ch) {
                        let val = ch.globals.seriesTotals.sort((a, b) => {
                          return b - a
                        }, 0);
                        let total = ch.globals.seriesTotals.reduce((a, b) => {
                          return a + b
                        }, 0);
                        let percent = (total !=0 ? ((val[0]/total) * 100).toFixed(0) : 0 ) + '%'
                        return kFormatter(percent);
                      }
                    }
                  }
                }
            }
          }
        }
      },
      donutClassificationChart: {
        series: [],
        chartOptions: {
          chart: {
            type: "donut",
            toolbar: {
              show: true
            }
          },
          colors: ["#007AFE", "#FEC400", "#F12B2C"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          labels: ["Tích cực", "Tiêu cực", "Trung lập"],
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                if (Number(val) === val && val % 1 !== 0) {
                  return kFormatter(val).toFixed(1);
                } else {
                  return kFormatter(val);
                }
              }
            },
            grid: {
              show: false
            }
          },
          legend: {
            position: "bottom",
            // offsetX: 0,
            // offsetY: 50
            markers: {
              fillColors: ["#007AFE", "#FEC400", "#F12B2C"]
            }
          }
        }
      },
      classificationChart: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            type: "line",
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          // title: {
          // text: 'Product Trends by Month',
          // align: 'left'
          // },
          grid: {
            row: {
              colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            labels: {
              showDuplicates: false,
              formatter: function(val) {
                if (!val) return val;
                let dateSplit = val.split("-"),
                  type = dateSplit[1],
                  dateTemp = moment(dateSplit[0], "YYYYMMDD");

                if (type === "W") return `Tuần ${dateTemp.isoWeek()}`;

                if (type === "M")
                  return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

                return val.slice(6, 8) + "/" + val.slice(4, 6);
              },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            categories: [],
            tooltip: {
              enabled: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                if (Number(val) === val && val % 1 !== 0) {
                  return kFormatter(val).toFixed(1);
                } else {
                  return kFormatter(val);
                }
              }
            },
            grid: {
              show: false
            }
          },
          legend: {
            position: "top",
            show: true,
            markers: {
              fillColors: ["#007AFE", "#FEC400", "#F12B2C"]
            }
          },
          colors: ["#007AFE", "#FEC400", "#F12B2C"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: ["#007AFE", "#FEC400", "#F12B2C"],
              shadeIntensity: 0.5,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          stroke: {
            curve: "smooth",
            // dashArray: [0, 8],
            width: [
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2,
              2
            ]
          }
        }
      },
      chartGenderOptions: {
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val + "%";
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },

        xaxis: {
          categories: [],
          position: 'top',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val + "%";
            }
          }

        },
        title: {
          text: 'Monthly Inflation in Argentina, 2002',
          floating: true,
          offsetY: 330,
          align: 'center',
          style: {
            color: '#444'
          }
        }
      },
      chartGenderSeries: [{
        name: 'Inflation',
        data: [ 0.5, 0.2]
      }]
    };
  },
  methods: {
    openURL: function(post){
      window.open(post.url, '_blank');
    },
    getImageByDomain: function(domain) {
      let url = "https://www.google.com/s2/favicons?domain=" + domain;
      return url;
    },
    refreshData: function() {
      this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
      this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
      let fromDate = this.dateRange.startDate;
      let toDate = this.dateRange.endDate;
      this.countDateRange(fromDate, toDate);
      let conditions = {
        from: fromDate,
        to: toDate,
        topicId: this.topicId,
        groupId: this.topicGroupId,
        beanTypeSocial: []
      };
      this.getMention(conditions).then(() => {
        //     // this.getMentionTopic(conditions);
      });
      this.getShade(conditions);
      this.getDataWorkChart(conditions);
      this.getDataClassificationChart(conditions);
      this.getSourceDataByDay(conditions);
      this.getTopDomain(conditions);
      this.getTopPostByClassification(conditions);
    },
    initScreen() {
      this.refreshData();
    },
    getMention(conditions) {
      return new Promise((resolve, reject) => {
        this.showDonutChartSource = false;

        if(this.typeTrial || this.typeTrial == 0) {
          this.$processor
            .post(`/data-trial/get-mention/${this.typeTrial}`, conditions)
            .then(mention => {
              this.mention = mention.data;

              this.totalMentioned = this.mention.totalMentioned;
              this.percentData = (
                (this.mention.totalMentioned / this.mention.countAllData) *
                100
              ).toFixed(0);
              this.percentMentioned = null;
              if (this.mention.countAllTo || this.mention.countAllFrom) {
                if (this.mention.countAllTo > this.mention.countAllFrom) {
                  this.increaseMentioned = true;
                  this.percentMentioned = (
                    ((this.mention.countAllTo - this.mention.countAllFrom) /
                      (this.mention.countAllFrom != 0
                        ? this.mention.countAllFrom
                        : 1)) *
                    100
                  ).toFixed(2);
                } else {
                  this.percentMentioned = (
                    ((this.mention.countAllFrom - this.mention.countAllTo) /
                      (this.mention.countAllTo != 0
                        ? this.mention.countAllTo
                        : 1)) *
                    100
                  ).toFixed(2);
                }
              }

              //Thao luan
              this.totalDiscuss = this.mention.totalComment;
              this.totalCommentFrom = this.mention.totalCommentFrom;
              this.percentDiscuss = null;
              if (this.mention.totalCommentTo || this.mention.totalCommentFrom) {
                if (this.mention.totalCommentTo > this.mention.totalCommentFrom) {
                  this.increaseDiscuss = true;
                  this.percentDiscuss = (
                    ((this.mention.totalCommentTo -
                      this.mention.totalCommentFrom) /
                      (this.mention.totalCommentFrom != 0
                        ? this.mention.totalCommentFrom
                        : 1)) *
                    100
                  ).toFixed(2);
                } else {
                  this.percentDiscuss = (
                    ((this.mention.totalCommentFrom -
                      this.mention.totalCommentTo) /
                      (this.mention.totalCommentTo != 0
                        ? this.mention.totalCommentTo
                        : 1)) *
                    100
                  ).toFixed(2);
                }
              }
              //Chia se
              this.totalShare = this.mention.totalShare;
              this.totalShareFrom = this.mention.totalShareFrom;
              this.percentShare = null;
              if (this.mention.totalShare || this.mention.totalShareFrom) {
                if (this.mention.totalShare > this.mention.totalShareFrom) {
                  this.increaseShare = true;
                  this.percentShare = (
                    ((this.mention.totalShare - this.mention.totalShareFrom) /
                      (this.mention.totalShareFrom != 0
                        ? this.mention.totalShareFrom
                        : 1)) *
                    100
                  ).toFixed(2);
                } else {
                  this.percentShare = (
                    ((this.mention.totalShareFrom - this.mention.totalShare) /
                      (this.mention.totalShare != 0
                        ? this.mention.totalShare
                        : 1)) *
                    100
                  ).toFixed(2);
                }
              }

              //Nguồn tin
              this.donutArticleChart.series = [];
              this.donutClassificationChart.chartOptions.labels = [];
              this.donutArticleChart.chartOptions.plotOptions.pie.donut.labels.total.label = '';
              this.donutArticleChart.chartOptions.labels = [
                this.$t("news"),
                "Facebook",
                "Youtube",
                "Twitter",
                "Instagram",
                "Tiktok",
                "Forum",
                "Blog & Website",
                this.$t("sourceSpecial")
              ];
              this.donutArticleChart.series.push(
                this.mention.countNews,
                this.mention.countSocialNetwork,
                this.mention.countYoutube,
                this.mention.countTwitter,
                this.mention.countInstagram,
                this.mention.countTikok,
                this.mention.countForum,
                this.mention.countBlogAndWebsite,
                this.mention.countOther
              );
              let sortSource = [];
              sortSource = [
                {label: this.$t("news"), value: this.mention.countNews},
                {label: 'Facebook', value: this.mention.countSocialNetwork},
                {label: 'Youtube', value: this.mention.countYoutube},
                {label: 'Twitter', value: this.mention.countTwitter},
                {label: 'Instagram', value: this.mention.countInstagram},
                {label: 'Tiktok', value: this.mention.countTiktok},
                {label: 'Forum', value: this.mention.countForum},
                {label: 'Blog & Website', value: this.mention.countBlogAndWebsite},
                {label:  this.$t("sourceSpecial"), value: this.mention.countOther}
              ]
              sortSource = sortSource.sort((a, b) => {
                return b.value - a.value;
              });
              let nameTopSource = sortSource[0].label;
              this.donutArticleChart.chartOptions.plotOptions.pie.donut.labels.total.label = nameTopSource;
              this.showDonutChartSource = true;
              // if (this.to.getDate() == this.from.getDate())
              //     this.percentDiscuss = null;

              //this.$vs.loading.close();
              resolve();
            })
            .catch(() => reject());
        }
        else {
          this.$processor
            .post("/user-data/get-mention", conditions)
            .then(mention => {
              this.mention = mention.data;

              this.totalMentioned = this.mention.totalMentioned;
              this.percentData = (
                (this.mention.totalMentioned / this.mention.countAllData) *
                100
              ).toFixed(0);
              this.percentMentioned = null;
              if (this.mention.countAllTo || this.mention.countAllFrom) {
                if (this.mention.countAllTo > this.mention.countAllFrom) {
                  this.increaseMentioned = true;
                  this.percentMentioned = (
                    ((this.mention.countAllTo - this.mention.countAllFrom) /
                      (this.mention.countAllFrom != 0
                        ? this.mention.countAllFrom
                        : 1)) *
                    100
                  ).toFixed(2);
                } else {
                  this.percentMentioned = (
                    ((this.mention.countAllFrom - this.mention.countAllTo) /
                      (this.mention.countAllTo != 0
                        ? this.mention.countAllTo
                        : 1)) *
                    100
                  ).toFixed(2);
                }
              }

              //Thao luan
              this.totalDiscuss = this.mention.totalComment;
              this.totalCommentFrom = this.mention.totalCommentFrom;
              this.percentDiscuss = null;
              if (this.mention.totalCommentTo || this.mention.totalCommentFrom) {
                if (this.mention.totalCommentTo > this.mention.totalCommentFrom) {
                  this.increaseDiscuss = true;
                  this.percentDiscuss = (
                    ((this.mention.totalCommentTo -
                      this.mention.totalCommentFrom) /
                      (this.mention.totalCommentFrom != 0
                        ? this.mention.totalCommentFrom
                        : 1)) *
                    100
                  ).toFixed(2);
                } else {
                  this.percentDiscuss = (
                    ((this.mention.totalCommentFrom -
                      this.mention.totalCommentTo) /
                      (this.mention.totalCommentTo != 0
                        ? this.mention.totalCommentTo
                        : 1)) *
                    100
                  ).toFixed(2);
                }
              }
              //Chia se
              this.totalShare = this.mention.totalShare;
              this.totalShareFrom = this.mention.totalShareFrom;
              this.percentShare = null;
              if (this.mention.totalShare || this.mention.totalShareFrom) {
                if (this.mention.totalShare > this.mention.totalShareFrom) {
                  this.increaseShare = true;
                  this.percentShare = (
                    ((this.mention.totalShare - this.mention.totalShareFrom) /
                      (this.mention.totalShareFrom != 0
                        ? this.mention.totalShareFrom
                        : 1)) *
                    100
                  ).toFixed(2);
                } else {
                  this.percentShare = (
                    ((this.mention.totalShareFrom - this.mention.totalShare) /
                      (this.mention.totalShare != 0
                        ? this.mention.totalShare
                        : 1)) *
                    100
                  ).toFixed(2);
                }
              }

              //Nguồn tin
              this.donutArticleChart.series = [];
              this.donutClassificationChart.chartOptions.labels = [];
              this.donutArticleChart.chartOptions.plotOptions.pie.donut.labels.total.label = '';
              this.donutArticleChart.chartOptions.labels = [
                this.$t("news"),
                "Facebook",
                "Youtube",
                "Twitter",
                "Instagram",
                "Tiktok",
                "Forum",
                "Blog & Website",
                this.$t("sourceSpecial")
              ];
              this.donutArticleChart.series.push(
                this.mention.countNews,
                this.mention.countSocialNetwork,
                this.mention.countYoutube,
                this.mention.countTwitter,
                this.mention.countInstagram,
                this.mention.countTiktok,
                this.mention.countForum,
                this.mention.countBlogAndWebsite,
                this.mention.countOther
              );
              let sortSource = [];
              sortSource = [
                {label: this.$t("news"), value: this.mention.countNews},
                {label: 'Facebook', value: this.mention.countSocialNetwork},
                {label: 'Youtube', value: this.mention.countYoutube},
                {label: 'Twitter', value: this.mention.countTwitter},
                {label: 'Instagram', value: this.mention.countInstagram},
                {label: 'Tiktok', value: this.mention.countTiktok},
                {label: 'Forum', value: this.mention.countForum},
                {label: 'Blog & Website', value: this.mention.countBlogAndWebsite},
                {label:  this.$t("sourceSpecial"), value: this.mention.countOther}
              ]
              sortSource = sortSource.sort((a, b) => {
                return b.value - a.value;
              });
              let nameTopSource = sortSource[0].label;
              this.donutArticleChart.chartOptions.plotOptions.pie.donut.labels.total.label = nameTopSource;
              this.showDonutChartSource = true;
              // if (this.to.getDate() == this.from.getDate())
              //     this.percentDiscuss = null;

              //this.$vs.loading.close();
              resolve();
            })
            .catch(() => reject());
        }
      });
    },
    getDataWorkChart(conditions) {
      this.showWorkChart = false;
      let that = this;
      if (this.typeTrial || this.typeTrial == 0){
        this.$processor
        .post(`/data-trial/get-work-by-day/${this.typeTrial}`, conditions)
        .then(res => {
          res.data.mentionByDays = this.optimizedChart(res.data.mentionByDays);
          res.data.commentByDays = this.optimizedChart(res.data.commentByDays);
          res.data.shareByDays = this.optimizedChart(res.data.shareByDays);

          that.workChartData = res.data;
          let mentionByDays = {
            name: this.$t("title.mentioned"),
            data: that.workChartData.mentionByDays.map(x => {
              return x.totalData;
            })
          };
          let commentByDays = {
            name: this.$t("title.comment"),
            data: that.workChartData.commentByDays.map(x => {
              return x.totalData;
            })
          };
          let shareByDays = {
            name: this.$t("title.share"),
            data: that.workChartData.shareByDays.map(x => {
              return x.totalData;
            })
          };
          that.capacityChart.series = [];
          that.capacityChart.chartOptions.xaxis.categories = [];
          that.capacityChart.chartOptions.xaxis.categories.push(
            ...that.workChartData.mentionByDays.map(x => {
              return x.stringDate;
            })
          );
          that.capacityChart.series.push(
            mentionByDays,
            commentByDays,
            shareByDays
          );
          that.showWorkChart = true;
          that.$vs.loading.close();
        });
      }else {
        this.$processor
        .post("/user-data/get-work-by-day", conditions)
        .then(res => {
          res.data.mentionByDays = this.optimizedChart(res.data.mentionByDays);
          res.data.commentByDays = this.optimizedChart(res.data.commentByDays);
          res.data.shareByDays = this.optimizedChart(res.data.shareByDays);

          that.workChartData = res.data;
          let mentionByDays = {
            name: this.$t("title.mentioned"),
            data: that.workChartData.mentionByDays.map(x => {
              return x.totalData;
            })
          };
          let commentByDays = {
            name: this.$t("title.comment"),
            data: that.workChartData.commentByDays.map(x => {
              return x.totalData;
            })
          };
          let shareByDays = {
            name: this.$t("title.share"),
            data: that.workChartData.shareByDays.map(x => {
              return x.totalData;
            })
          };
          that.capacityChart.series = [];
          that.capacityChart.chartOptions.xaxis.categories = [];
          that.capacityChart.chartOptions.xaxis.categories.push(
            ...that.workChartData.mentionByDays.map(x => {
              return x.stringDate;
            })
          );
          that.capacityChart.series.push(
            mentionByDays,
            commentByDays,
            shareByDays
          );
          that.showWorkChart = true;
          that.$vs.loading.close();
        });
      }
    },
    getDataClassificationChart(conditions) {
      this.showClassificationChart = false;
      let that = this;
      if (this.typeTrial || this.typeTrial == 0){
        this.$processor
        .post(`/data-trial/get-shade-by-day/${this.typeTrial}`, conditions)
        .then(res => {
          res.data.positives = this.optimizedChart(res.data.positives);
          res.data.neutrals = this.optimizedChart(res.data.neutrals);
          res.data.negatives = this.optimizedChart(res.data.negatives);

          that.shadeChartData = res.data;
          let positives = {
            name: this.$t("title.positive"),
            data: that.shadeChartData.positives.map(x => {
              return x.totalData;
            })
          };
          let neutrals = {
            name: this.$t("title.neutral"),
            data: that.shadeChartData.neutrals.map(x => {
              return x.totalData;
            })
          };
          let negatives = {
            name: this.$t("title.negative"),
            data: that.shadeChartData.negatives.map(x => {
              return x.totalData;
            })
          };
          that.classificationChart.series = [];
          that.classificationChart.chartOptions.xaxis.categories = [];
          that.classificationChart.chartOptions.xaxis.categories.push(
            ...that.shadeChartData.positives.map(x => {
              return x.stringDate;
            })
          );
          that.classificationChart.series.push(positives, neutrals, negatives);
          that.showClassificationChart = true;
        });
      }else {
        this.$processor
        .post("/user-data/get-shade-by-day", conditions)
        .then(res => {
          res.data.positives = this.optimizedChart(res.data.positives);
          res.data.neutrals = this.optimizedChart(res.data.neutrals);
          res.data.negatives = this.optimizedChart(res.data.negatives);

          that.shadeChartData = res.data;
          let positives = {
            name: this.$t("title.positive"),
            data: that.shadeChartData.positives.map(x => {
              return x.totalData;
            })
          };
          let neutrals = {
            name: this.$t("title.neutral"),
            data: that.shadeChartData.neutrals.map(x => {
              return x.totalData;
            })
          };
          let negatives = {
            name: this.$t("title.negative"),
            data: that.shadeChartData.negatives.map(x => {
              return x.totalData;
            })
          };
          that.classificationChart.series = [];
          that.classificationChart.chartOptions.xaxis.categories = [];
          that.classificationChart.chartOptions.xaxis.categories.push(
            ...that.shadeChartData.positives.map(x => {
              return x.stringDate;
            })
          );
          that.classificationChart.series.push(positives, neutrals, negatives);
          that.showClassificationChart = true;
        });
      }
    },
    getShade(conditions) {
      this.showDonutChartClassification = false;
      let that = this;
      if(this.typeTrial || this.typeTrial == 0) {
        that.$processor.post(`/data-trial/get-shade/${this.typeTrial}`, conditions).then(shade => {
          that.shade = shade.data;

          let totalPositive =
            that.shade.totalPositiveSocialNetwork +
            that.shade.totalPositiveNews +
            that.shade.totalPositiveOther;
          let totalNeutral =
            that.shade.totalNeutralSocialNetwork +
            that.shade.totalNeutralNews +
            that.shade.totalNeutralOther;
          let totalNegative =
            that.shade.totalNegativeSocialNetwork +
            that.shade.totalNegativeNews +
            that.shade.totalNegativeOther;
          that.donutClassificationChart.series = [];
          that.donutClassificationChart.series = [
            totalPositive,
            totalNeutral,
            totalNegative
          ];
          that.donutClassificationChart.chartOptions.labels = [];
          that.donutClassificationChart.chartOptions.labels = [
            this.$t("title.positive"),
            this.$t("title.neutral"),
            this.$t("title.negative")
          ];
          that.showDonutChartClassification = true;
        });
      }
      else {
        that.$processor.post("/user-data/get-shade", conditions).then(shade => {
          that.shade = shade.data;

          let totalPositive =
            that.shade.totalPositiveSocialNetwork +
            that.shade.totalPositiveNews +
            that.shade.totalPositiveOther;
          let totalNeutral =
            that.shade.totalNeutralSocialNetwork +
            that.shade.totalNeutralNews +
            that.shade.totalNeutralOther;
          let totalNegative =
            that.shade.totalNegativeSocialNetwork +
            that.shade.totalNegativeNews +
            that.shade.totalNegativeOther;
          that.donutClassificationChart.series = [];
          that.donutClassificationChart.series = [
            totalPositive,
            totalNeutral,
            totalNegative
          ];
          that.donutClassificationChart.chartOptions.labels = [];
          that.donutClassificationChart.chartOptions.labels = [
            this.$t("title.positive"),
            this.$t("title.neutral"),
            this.$t("title.negative")
          ];
          that.showDonutChartClassification = true;
        });
      }
    },
    optimizedChart: function(data) {
      data = data.sort(function(a, b) {
        return parseInt(a.stringDate) - parseInt(b.stringDate);
      });
      data.map(item => {
        let date = moment(item.stringDate, "YYYYMMDD");
        item.month = date.format("Y") + date.format("M");
        item.week = date.isoWeek();
        item.day = date.format("D");
        return item;
      });

      let result = [];
      data.reduce(function(res, value) {
        if (data.length <= 21) {
          if (!res[value.day]) {
            res[value.day] = {
              day: value.day,
              stringDate: value.stringDate,
              totalData: 0
            };
            result.push(res[value.day]);
          }
          res[value.day].totalData += value.totalData;
          res[value.day].stringDate += "-D";
          return res;
        }
        if (14 < data.length && data.length < 62) {
          if (!res[value.week]) {
            res[value.week] = {
              week: value.week,
              stringDate: value.stringDate,
              totalData: 0
            };
            result.push(res[value.week]);
          }
          res[value.week].totalData += value.totalData;
          res[value.week].stringDate += "-W";
          return res;
        } else if (data.length > 62) {
          if (!res[value.month]) {
            res[value.month] = {
              month: value.month,
              stringDate: value.stringDate,
              totalData: 0
            };
            result.push(res[value.month]);
          }
          res[value.month].totalData += value.totalData;
          res[value.month].stringDate += "-M";
          return res;
        }
      }, {});
      data = result;
      return data;
    },
    getSourceDataByDay(conditions) {
      this.showArticleChart = false;
      let that = this;
      if (this.typeTrial || this.typeTrial == 0) {
        that.$processor
        .post(`/data-trial/get-source-data-by-day/${this.typeTrial}`, conditions)
        .then(sourceData => {
          sourceData.data.sourceDataSocial = this.optimizedChart(
            sourceData.data.sourceDataSocial
          );
          sourceData.data.sourceDataNews = this.optimizedChart(
            sourceData.data.sourceDataNews
          );
          sourceData.data.sourceDataYoutube = this.optimizedChart(
            sourceData.data.sourceDataYoutube
          );
          sourceData.data.sourceDataTwitter = this.optimizedChart(
            sourceData.data.sourceDataTwitter
          );
          sourceData.data.sourceDataInstagram = this.optimizedChart(
            sourceData.data.sourceDataInstagram
          );
          sourceData.data.sourceDataForum = this.optimizedChart(
            sourceData.data.sourceDataForum
          );
          sourceData.data.sourceDataOther = this.optimizedChart(
            sourceData.data.sourceDataOther
          );
          sourceData.data.sourceDataBlogAndWebsite = this.optimizedChart(
            sourceData.data.sourceDataBlogAndWebsite
          );

          that.sourceData = sourceData.data;
          let social = {
            name: "Facebook",
            data: that.sourceData.sourceDataSocial.map(x => {
              return x.totalData;
            })
          };
          let news = {
            name: this.$t("news"),
            data: that.sourceData.sourceDataNews.map(x => {
              return x.totalData;
            })
          };
          let youtube = {
            name: "Youtube",
            data: that.sourceData.sourceDataYoutube.map(x => {
              return x.totalData;
            })
          };
          let twitter = {
            name: "Twitter",
            data: that.sourceData.sourceDataTwitter.map(x => {
              return x.totalData;
            })
          };
          let instagram = {
            name: "Instagram",
            data: that.sourceData.sourceDataInstagram.map(x => {
              return x.totalData;
            })
          };
          let forum = {
            name: "Forum",
            data: that.sourceData.sourceDataForum.map(x => {
              return x.totalData;
            })
          };
          let blogAndWebsite = {
            name: "Blog & Website",
            data: that.sourceData.sourceDataBlogAndWebsite.map(x => {
              return x.totalData;
            })
          };
          let other = {
            name: this.$t("sourceSpecial"),
            data: that.sourceData.sourceDataOther.map(x => {
              return x.totalData;
            })
          };
          that.articleChart.series = [];
          that.articleChart.chartOptions.xaxis.categories = [];
          that.articleChart.chartOptions.xaxis.categories.push(
            ...that.sourceData.sourceDataNews.map(x => {
              return x.stringDate;
            })
          );
          that.articleChart.series.push(
            news,
            social,
            youtube,
            twitter,
            // instagram,
            forum,
            blogAndWebsite,
            other
          );
          this.showArticleChart = true;
          this.$vs.loading.close();
        });
      }else {
        that.$processor
        .post("/user-data/get-source-data-by-day", conditions)
        .then(sourceData => {
          sourceData.data.sourceDataSocial = this.optimizedChart(
            sourceData.data.sourceDataSocial
          );
          sourceData.data.sourceDataNews = this.optimizedChart(
            sourceData.data.sourceDataNews
          );
          sourceData.data.sourceDataYoutube = this.optimizedChart(
            sourceData.data.sourceDataYoutube
          );
          sourceData.data.sourceDataTwitter = this.optimizedChart(
            sourceData.data.sourceDataTwitter
          );
          sourceData.data.sourceDataInstagram = this.optimizedChart(
            sourceData.data.sourceDataInstagram
          );
          sourceData.data.sourceDataTiktok = this.optimizedChart(
            sourceData.data.sourceDataTiktok
          );
          sourceData.data.sourceDataForum = this.optimizedChart(
            sourceData.data.sourceDataForum
          );
          sourceData.data.sourceDataOther = this.optimizedChart(
            sourceData.data.sourceDataOther
          );
          sourceData.data.sourceDataBlogAndWebsite = this.optimizedChart(
            sourceData.data.sourceDataBlogAndWebsite
          );

          that.sourceData = sourceData.data;
          let social = {
            name: "Facebook",
            data: that.sourceData.sourceDataSocial.map(x => {
              return x.totalData;
            })
          };
          let news = {
            name: this.$t("news"),
            data: that.sourceData.sourceDataNews.map(x => {
              return x.totalData;
            })
          };
          let youtube = {
            name: "Youtube",
            data: that.sourceData.sourceDataYoutube.map(x => {
              return x.totalData;
            })
          };
          let twitter = {
            name: "Twitter",
            data: that.sourceData.sourceDataTwitter.map(x => {
              return x.totalData;
            })
          };
          let instagram = {
            name: "Instagram",
            data: that.sourceData.sourceDataInstagram.map(x => {
              return x.totalData;
            })
          };
          let tiktok = {
            name: "Tiktok",
            data: that.sourceData.sourceDataTiktok.map(x => {
              return x.totalData;
            })
          };
          let forum = {
            name: "Forum",
            data: that.sourceData.sourceDataForum.map(x => {
              return x.totalData;
            })
          };
          let blogAndWebsite = {
            name: "Blog & Website",
            data: that.sourceData.sourceDataBlogAndWebsite.map(x => {
              return x.totalData;
            })
          };
          let other = {
            name: this.$t("sourceSpecial"),
            data: that.sourceData.sourceDataOther.map(x => {
              return x.totalData;
            })
          };
          that.articleChart.series = [];
          that.articleChart.chartOptions.xaxis.categories = [];
          that.articleChart.chartOptions.xaxis.categories.push(
            ...that.sourceData.sourceDataNews.map(x => {
              return x.stringDate;
            })
          );
          that.articleChart.series.push(
            news,
            social,
            youtube,
            twitter,
            instagram,
            tiktok,
            forum,
            blogAndWebsite,
            other
          );
          this.showArticleChart = true;
          this.$vs.loading.close();
        });
      }
    },
    getTopDomain: function(conditions) {
      this.showTopDomain = false;
      if (this.typeTrial || this.typeTrial == 0) {
        this.$processor
        .post(`/data-trial/get-top-domain/${this.typeTrial}`, conditions)
        .then(res => {
          let index = 0;
          this.listTopDomain = res.data.map(el => {
            let object = {};
            index++;
            object["domain"] = el.domain;
            object["url"] = el.url;
            object["count"] = el.countPost;
            object["stt"] = index;
            let name = el.domain.split(".")[0];
            object["name"] = name.charAt(0).toUpperCase() + name.slice(1);

            let percentTopic = 0;
            if (
              el.countPositive > el.countNeutral &&
              el.countPositive > el.countNegative
            ) {
              percentTopic = ((el.countPositive / el.countPost) * 100).toFixed(
                0
              );
              object["percent"] = !isNaN(percentTopic)
                ? parseInt(percentTopic)
                : 0;
              object["color"] = "#007AFE";
            }
            if (
              el.countNeutral > el.countPositive &&
              el.countNeutral > el.countNegative
            ) {
              percentTopic = ((el.countNeutral / el.countPost) * 100).toFixed(
                0
              );
              object["percent"] = !isNaN(percentTopic)
                ? parseInt(percentTopic)
                : 0;
              object["color"] = "#FEC400";
            }
            if (
              el.countNegative > el.countPositive &&
              el.countNegative > el.countNeutral
            ) {
              percentTopic = ((el.countNegative / el.countPost) * 100).toFixed(
                0
              );
              object["percent"] = !isNaN(percentTopic)
                ? parseInt(percentTopic)
                : 0;
              object["color"] = "#F12B2C";
            }
            return object;
          });
          this.showTopDomain = true;
        });
      }else {
        this.$processor
        .post("/user-data/get-top-domain", conditions)
        .then(res => {
          let index = 0;
          this.listTopDomain = res.data.map(el => {
            let object = {};
            index++;
            object["domain"] = el.domain;
            object["url"] = el.url;
            object["count"] = el.countPost;
            object["stt"] = index;
            let name = el.domain.split(".")[0];
            object["name"] = name.charAt(0).toUpperCase() + name.slice(1);

            let percentTopic = 0;
            if (
              el.countPositive > el.countNeutral &&
              el.countPositive > el.countNegative
            ) {
              percentTopic = ((el.countPositive / el.countPost) * 100).toFixed(
                0
              );
              object["percent"] = !isNaN(percentTopic)
                ? parseInt(percentTopic)
                : 0;
              object["color"] = "#007AFE";
            }
            if (
              el.countNeutral > el.countPositive &&
              el.countNeutral > el.countNegative
            ) {
              percentTopic = ((el.countNeutral / el.countPost) * 100).toFixed(
                0
              );
              object["percent"] = !isNaN(percentTopic)
                ? parseInt(percentTopic)
                : 0;
              object["color"] = "#FEC400";
            }
            if (
              el.countNegative > el.countPositive &&
              el.countNegative > el.countNeutral
            ) {
              percentTopic = ((el.countNegative / el.countPost) * 100).toFixed(
                0
              );
              object["percent"] = !isNaN(percentTopic)
                ? parseInt(percentTopic)
                : 0;
              object["color"] = "#F12B2C";
            }
            return object;
          });
          this.showTopDomain = true;
        });
      }
    },
    getTopicGroups: function() {
      return new Promise((resolve, reject) => {
        if(this.typeTrial || this.typeTrial == 0){
          this.$business
            .post(`/topic-group/find-by-conditions/${this.typeTrial}`, {})
            .then(res => {
              this.optionGroupTopics = res.data;
              if (this.optionGroupTopics.length > 0) {
                this.optionGroupTopics = this.optionGroupTopics.map(el => {
                  return {
                    label: el.groupName,
                    value: el.id
                  };
                });
                this.optionGroupTopics.unshift({ label: "Khác", value: null });
                this.optionGroupTopics.sort(function(a, b) {
                  return b.value - a.value;
                });
                let selecteAll = { label: "Tất cả", value: null };
                this.optionGroupTopics = [selecteAll].concat(
                  this.optionGroupTopics
                );
              }
              this.findByTopicGroup(res.data);
              resolve();
            })
            .catch(() => reject());
        }
        else {
          this.$business
            .post("/topic-group/find-by-conditions", {})
            .then(res => {
              this.optionGroupTopics = res.data;
              if (this.optionGroupTopics.length > 0) {
                this.optionGroupTopics = this.optionGroupTopics.map(el => {
                  return {
                    label: el.groupName,
                    value: el.id
                  };
                });
                this.optionGroupTopics.unshift({ label: "Khác", value: null });
                this.optionGroupTopics.sort(function(a, b) {
                  return b.value - a.value;
                });
                let selecteAll = { label: "Tất cả", value: null };
                this.optionGroupTopics = [selecteAll].concat(
                  this.optionGroupTopics
                );
              }
              this.findByTopicGroup(res.data);
              resolve();
            })
            .catch(() => reject());
        }

      });
    },
    getTopic() {
      return new Promise((resolve, reject) => {
        let conditions = {};
      if(this.typeTrial || this.typeTrial == 0) {
        this.$business
          .post(`/topic/find-by-conditions/${this.typeTrial}`, conditions)
          .then(topics => {
            this.$business
              .post(`share-topic/get-all-share`, conditions)
              .then(res => {
                let listTopics = [
                  ...topics.data,
                  ...res.data.filter(item => item.status === 1)
                ];
                this.optionTopics = listTopics;
                this.listTopics = listTopics;
                let result = null;
                let arrGroupTopic = this.optionGroupTopics;
                arrGroupTopic.forEach(filter => {
                  result = this.optionTopics.filter(
                    topic => topic.topicGroupId == filter.value
                  );
                  if (result < 1) {
                    let index = arrGroupTopic.indexOf(filter);
                    this.optionGroupTopics.splice(index, 1);
                  }
                });
                this.optionTopics.forEach(item => {
                  if (item.favourite) {
                    this.searchByTopic(item);
                  }
                  if (item.topicName && item.topicName.length > 23) {
                    item.topicName = item.topicName.slice(0, 23) + "...";
                  }
                  if (
                    !this.optionGroupTopics.find(
                      el => el.value == item.topicGroupId
                    )
                  ) {
                    item.isOther = true;
                  } else {
                    item.isOther = false;
                  }
                });
                let selectedAll = { topicName: "Tất cả", id: null };
                if (this.topicGroupId) {
                  this.optionTopics = this.optionTopics.filter(
                    topic => topic.topicGroupId ==this.topicGroupId
                  );
                }
                this.optionTopics = [selectedAll].concat(this.optionTopics);
                this.initScreen();
              });
          });
      }
      else {
        this.$business
          .post("/topic/find-by-conditions", conditions)
          .then(topics => {
            this.$business
              .post(`share-topic/get-all-share`, conditions)
              .then(res => {
                let a = this;
                let listTopics = [
                  ...topics.data,
                  ...res.data.filter(item => item.status === 1)
                ];
                this.optionTopics = listTopics;
                this.listTopics = listTopics;
                let result = null;
                let arrGroupTopic = this.optionGroupTopics;
                arrGroupTopic.forEach(filter => {
                  result = this.optionTopics.filter(
                    topic => topic.topicGroupId == filter.value
                  );
                  if (result < 1) {
                    let index = arrGroupTopic.indexOf(filter);
                    this.optionGroupTopics.splice(index, 1);
                  }
                });
                this.optionTopics.forEach(item => {
                  if (item.favourite) {
                    this.searchByTopic(item);
                  }
                  if (item.topicName && item.topicName.length > 23) {
                    item.topicName = item.topicName.slice(0, 23) + "...";
                  }
                  if (
                    !this.optionGroupTopics.find(
                      el => el.value == item.topicGroupId
                    )
                  ) {
                    item.isOther = true;
                  } else {
                    item.isOther = false;
                  }
                });
                let selectedAll = { topicName: "Tất cả", id: null };
                if (this.topicGroupId) {
                  this.optionTopics = this.optionTopics.filter(
                    topic => topic.topicGroupId ==this.topicGroupId
                  );
                }
                this.optionTopics = [selectedAll].concat(this.optionTopics);
                this.initScreen();
                this.findByTopic(this.optionTopics);
              });
          });
        }
      })
    },
    getTopPostByClassification: function(payload) {
      this.showTopKeyword = false;
      if(this.typeTrial || this.typeTrial == 0) {
        this.$processor
          .post(`/data-trial/get-top-classification/${this.typeTrial}`, payload)
          .then(response => {
            this.defaultWords = response.data;
            let index = 0;
            this.defaultWords = response.data.map(el => {
              let totalClassification = el.positive + el.negative + el.normal;
              let contennt = el.fullContents.filter(item => item.type == "text")
                .map(text => {
                  if (text.content) {
                    return text.content.trim();
                  }
                })
                .join("\n");
              let object = {};
              object["stt"] = ++index;
              object["title"] = el.title;
              object["content"] = contennt;
              object["value"] = totalClassification;
              object['url'] = el.url;
              let percentPost = 0;

              if (el.positive > el.normal && el.positive > el.negative) {
                percentPost = ((el.positive / totalClassification) * 100).toFixed(
                  0
                );
                object["percent"] = !isNaN(percentPost)
                  ? parseInt(percentPost)
                  : 0;
                object["color"] = "#007AFE";
              }
              if (el.normal > el.positive && el.normal > el.negative) {
                percentPost = ((el.normal / totalClassification) * 100).toFixed(
                  0
                );
                object["percent"] = !isNaN(percentPost)
                  ? parseInt(percentPost)
                  : 0;
                object["color"] = "#F12B2C";
              }
              if (el.negative > el.positive && el.negative > el.normal) {
                percentPost = ((el.negative / totalClassification) * 100).toFixed(
                  0
                );
                object["percent"] = !isNaN(percentPost)
                  ? parseInt(percentPost)
                  : 0;
                object["color"] = "#FEC400";
              }
              return object;
            });
            this.showTopKeyword = true;
          });
      }
      else {
        this.$processor
          .post("/user-data/get-top-classification", payload)
          .then(response => {
            this.defaultWords = response.data;
            let index = 0;
            this.defaultWords = response.data.map(el => {
              let totalClassification = el.positive + el.negative + el.normal;
              let contennt = el.fullContents.filter(item => item.type == "text")
                .map(text => {
                  if (text.content) {
                    return text.content.trim();
                  }
                })
                .join("\n");
              let object = {};
              object["stt"] = ++index;
              object["title"] = el.title;
              object["content"] = contennt;
              object["value"] = totalClassification;
              object['url'] = el.url;
              let percentPost = 0;

              if (el.positive > el.normal && el.positive > el.negative) {
                percentPost = ((el.positive / totalClassification) * 100).toFixed(
                  0
                );
                object["percent"] = !isNaN(percentPost)
                  ? parseInt(percentPost)
                  : 0;
                object["color"] = "#007AFE";
              }
              if (el.normal > el.positive && el.normal > el.negative) {
                percentPost = ((el.normal / totalClassification) * 100).toFixed(
                  0
                );
                object["percent"] = !isNaN(percentPost)
                  ? parseInt(percentPost)
                  : 0;
                object["color"] = "#F12B2C";
              }
              if (el.negative > el.positive && el.negative > el.normal) {
                percentPost = ((el.negative / totalClassification) * 100).toFixed(
                  0
                );
                object["percent"] = !isNaN(percentPost)
                  ? parseInt(percentPost)
                  : 0;
                object["color"] = "#FEC400";
              }
              return object;
            });
            this.showTopKeyword = true;
          });
      }
    },
    exportExcel: function() {
      const detail = localStorage.getItem("userInfo");
      const user = JSON.parse(detail);
      const payload = {
        userId: user.id,
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        topicId: this.topicId
      };
      let apiPath = "statisticals/export-data";
      let packageApiPermission = this.$root.businessPackage.permissions.reduce((arr,item) => {
        arr.push(...item.functionApiPrefix.split(";"))
        return arr;
      }, []);
      let apiPermission = this.$root.permissionList.reduce((arr,item) => {
        arr.push(...item.functionApiPrefix.split(";"))
        return arr;
      }, []);
      if (apiPermission.includes(apiPath) && !packageApiPermission.includes(apiPath)) {
        return this.$vs.notify({
          text: this.$t('noPermission'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      this.$vs.loading();
      this.$report
        .post(`statisticals/export-data`, payload)
        .then(response => {
          window.open(
            authConfig.reportDomain +
              "download/" +
              response.data +
              "?access_token=" +
              localStorage.getItem("access_token"),
            "_blank"
          );
          this.$vs.loading.close();
          return this.$vs.notify({
            text: this.$t("dashboardAnalytics.textSuccess"),
            icon: "icon-alert",
            iconPack: "feather",
            color: "primary"
          });
        })
        .catch(err => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text:
              err.response.data.message ||
              err.response.data.error_description ||
              err.response.data.error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    searchByTopic: function(item) {
      this.$vs.loading();
      this.topicGroupId = null;
      this.labelTopic = item.topicName;
      this.topicId = item.id;
      // this.selectedTopic = item;
      this.initScreen();
      this.$vs.loading.close();
    },
    filterByProjectList : function () {
      let id = this.$route.query.id
      this.$business.get(`topic-group/find-by-id/${id}`).then((res) => {
        const data = res.data;
        this.topicGroupByProjectList = data.groupName;
        this.filterProject = true;
      })
    },
    searchByTopicGroup: function(item) {
      this.$vs.loading();
      let selectedAll = { topicName: "Tất cả", id: null };
      this.optionTopics = [selectedAll].concat(this.optionTopics);
      let listTopics = this.listTopics;
      this.labelGroup = item.label;
      this.topicGroupId = item.value;
      this.topicId = null;
      this.labelTopic = 'Tất cả'
      this.initScreen();
      if (item.value)
        return (this.optionTopics = [selectedAll].concat(listTopics.filter(
          el => el.topicGroupId == item.value
        )));
      if (item.label.includes("Khác") && item.value == null)
        return (this.optionTopics = [selectedAll].concat(listTopics.filter(el => el.isOther)));
      if (item.label.includes("Tất cả") && item.value == null)
        return (this.optionTopics = this.listTopics);
      this.$vs.loading.close();
    },
    getDataByDay: function() {
      this.$vs.loading();
      let day = new Date();
      day.setHours(23, 59, 59);
      this.dateRange.endDate = day;
      this.dateRange.startDate = new Date().setHours(0, 0, 0);
      this.checkSelectedDay = true;
      this.checkselectedWeeks = false;
      this.checkSelectedMonth = false;
      this.initScreen();
      this.$vs.loading.close();
    },
    getDataByMonth: function() {
      this.$vs.loading();
      let month = new Date();
      month.setDate(month.getDate() - 29);
      month.setHours(0, 0, 0);
      this.dateRange.startDate = month;
      this.dateRange.endDate = new Date().setHours(23, 59, 59);
      this.checkSelectedMonth = true;
      this.checkselectedWeeks = false;
      this.checkSelectedDay = false;
      this.initScreen();
      this.$vs.loading.close();
    },
    getDataByWeeks: function() {
      this.$vs.loading();
      let weeks = new Date();
      weeks.setDate(weeks.getDate() - 6);
      weeks.setHours(0, 0, 0);
      this.dateRange.startDate = weeks;
      this.dateRange.endDate = new Date().setHours(23, 59, 59);
      this.checkselectedWeeks = true;
      this.checkSelectedDay = false;
      this.checkSelectedMonth = false;
      this.initScreen();
      this.$vs.loading.close();
    },
    eArabic: function(x) {
      return x.toLocaleString("de-DE");
    },
    countDateRange: function(fromDate, toDate) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(fromDate);
      const secondDate = new Date(toDate);
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      this.countDays = diffDays;
    },
    findByTopicGroup: function(topicGroups){
      let groupId = this.$route.query.groupId;
      if (groupId) {
        let topicGroup = topicGroups.find(group => group.id == groupId);
        if (topicGroup) {
          this.topicGroupId = groupId;
          this.labelGroup = topicGroup.groupName;
        }
        else {
          this.topicGroupId = null;
          this.labelGroup = this.$t('all');
        }
      }
    },
    findByTopic: function(topic){
      let id = this.$route.query.id;
      if (id) {
        this.topicId = id;
        let result = topic.find(topic => topic.id == id);
        if (result) this.labelTopic = result.topicName;
      }
    },
    filterTopicGroup: function(){
      let id = this.$route.query.id;
      if (id){
        let topicGroup = this.optionGroupTopics.find(el => el.value == id)
        if (topicGroup) {
          this.labelGroup = topicGroup.label;
          this.topicGroupId = topicGroup.value;
        }
        this.initScreen();
      }
    }
  },
  created() {
    let typeTrial = JSON.parse(localStorage.getItem('dataTrial'));
    if (typeTrial || typeTrial == 0) this.typeTrial = typeTrial;
    this.$eventBus.$on("i18n", () => {
      this.labelGroup = this.$t('all');
      this.labelTopic = this.$t('all');
      this.initScreen();
    });
    this.getTopicGroups().then(() => {
      this.getTopic();
      this.filterTopicGroup();
    });
  },
  mounted(){
  }
};
function kFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}
</script>
<style lang="scss">
.includeIcon {
  // width: 100%;
}
.label-selected {
  text-align: left;
}
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
@media (max-width: 1440px) {
  .statistic {
    padding: 0 !important;
  }
}

.reportrange-text {
  border-radius: 10px;
  min-width: 200px;
}
.button-download {
  position: absolute;
  right: 22px;
  top: 20px;
}
.selected-dropdown {
  min-width: 255px;
  min-height: 54px;
}
.selected-date {
  min-width: 144px;
  min-height: 54px;
}
.border-mentioned {
  border-top: 1px solid #e5e5e5;
}
.border-right-mentioned {
  border-right: 1px solid #e5e5e5;
}

.text-title {
  font-size: 19px;
  font-weight: bold;
}
.text-time-title {
  font-size: 12px;
  color: #707070;
}
.count-mentioned {
  font-size: 36px;
  color: #2f80ed;
  font-weight: bold;
}
.count-post {
  font-size: 36px;
  color: #27ae60;
  font-weight: bold;
}
.count-comment {
  font-size: 36px;
  color: #9b51e0;
  font-weight: bold;
}
.count-share {
  font-size: 36px;
  color: #f2994a;
  font-weight: bold;
}
.arrow-up {
  width: 14px;
  color: #29cc97;
}
.arrow-down {
  width: 14px;
  color: #f12b2c;
}
.percent-count {
  font-size: 16px;
  color: #29cc97;
}
.percent-count-down {
  font-size: 16px;
  color: #f12b2c;
}
.height-card {
  height: 396px;
}
.keyword-chart {
  max-height: 315px;
}
.keyword-chart-views {
  max-height: 250px;
}
.percent-keyword {
  width: 50pt;
}
.percent-keyword-source {
  width: 10%;
  height: 20px;
  background-color: #2f80ed;
}
.percent-old-keyword-source {
  width: 10%;
  height: 20px;
  background-color: #ecf0f5;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
.text-value {
  font-size: 12px;
}
.text-decoration-line {
  text-decoration-line: underline;
  color: #2f80ed;
}
.margin-top {
  margin-top: -18px;
}
.image-center {
  text-align: center;
}
.title-content {
  font-size: 14px;
  font-weight: bold;
  color: #5e5873;
}
.text-content {
  font-size: 12px;
  color: #b9b9c3;
}
.table-dashboard .con-tablex .vs-con-tbody {
  max-height: 315px;
  z-index: 1;
}
.table-dashboard .con-tablex .vs-con-tbody .vs-table--tbody-table {
  min-width: 320px !important;
}
.font-weight-bold {
  font-weight: bold;
}
.vs-table--tbody-table .tr-values.selected {
  cursor: default
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
@media screen and (max-width: 1366px) {
  .vs-con-table .vs-con-tbody {
    overflow: auto;
  }
}
@media screen and (min-width: 1920px) {
  .vs-con-table .vs-con-tbody {
    overflow: hidden;
  }
}
</style>
